import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Formik, Form } from "formik";
import { Paper } from "@mui/material";
import merge from "lodash/merge";
import DsokCustomerDetailLayout from "../components/DsokCustomerDetailLayout";
import DsokCustomerDetailDirtySync from "../components/DsokCustomerDetailDirtySync";
import DsokCustomerDetailSectionRegister from "../components/DsokCustomerDetailSectionRegister";
import { useDsokCustomerDetail } from "../data/useDsokCustomerDetail";
import BillingField, {
  BILLING_FIELD_SCHEMA,
} from "app/pages/customers/dsok/fields/BillingField";

const DsokCustomerBillingPage = () => {
  const { t } = useTranslation();
  const { customer } = useDsokCustomerDetail();

  const formInitialValues = useMemo(
    () => ({
      billing: merge(
        {},
        BILLING_FIELD_SCHEMA,
        customer?.dsokSettings?.settings?.billing,
      ),
    }),
    [customer],
  );

  return (
    <DsokCustomerDetailLayout
      lastBreadcrumbLabel={t("dsokCustomerDetail.sections.billing.title", {
        defaultValue: "Faktúrácia",
      })}
    >
      <Paper
        variant="outlined"
        sx={{ bgcolor: "background.paper", p: 2, borderRadius: 1 }}
      >
        <Formik
          initialValues={formInitialValues}
          enableReinitialize
          onSubmit={() => {}}
        >
          <Form>
            <DsokCustomerDetailDirtySync />
            <DsokCustomerDetailSectionRegister
              sectionId="billing"
              getPayload={(values) => values?.billing ?? null}
            />
            <BillingField hideSectionTitle customerId={customer?.id} />
          </Form>
        </Formik>
      </Paper>
    </DsokCustomerDetailLayout>
  );
};

export default DsokCustomerBillingPage;
